module.exports = __webpack_public_path__ + "assets/img/Type E (51).0b652636.jpg";